import React from 'react';
import { bool, shape, string } from 'prop-types';

const InformerColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3 1.5H15C15.825 1.5 16.5 2.175 16.5 3V12C16.5 12.825 15.825 13.5 15 13.5H4.5L1.5 16.5L1.5075 3C1.5075 2.175 2.175 1.5 3 1.5ZM3.8775 12H15V3H3V12.8775L3.8775 12ZM8.25 9H9.75V10.5H8.25V9ZM9.75 4.5H8.25V7.5H9.75V4.5Z" fill="currentColor" />
  </svg>
);

InformerColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default InformerColor;
